<div class="flex my-3">	
	<p-table
		#tableCustomersList
		dataKey="i"
		class="w-full"
		[value]="eventMessages"
		[lazy]="true"
		(onLazyLoad)="loadEvents($event)"
		[paginator]="true"
		[totalRecords]="totalRecords"
		[loading]="loading"
		[first]="tableFirst"
		[rows]="pageSize"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
		[autoLayout]="true"
		responsiveLayout="stack">

		<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
			<tr>
				<th><div class="flex align-items-center justify-content-center">{{ 'EVENT_DATE' | translate }}</div></th>
				<th><div class="flex align-items-center justify-content-center">{{ 'TIMEZONE' | translate }}</div></th>
				<th><div class="flex align-items-center justify-content-center">{{ 'USERNAME' | translate }}</div></th>
				<th><div class="flex align-items-center justify-content-center">{{ 'DEVICE' | translate }}</div></th>
				<th><div class="flex align-items-center justify-content-center">{{ 'MTMA_DIAG_FILTER_EVENT_TYPE' | translate }}</div></th>
				<th><div class="flex align-items-center justify-content-center">{{ 'EVENT' | translate }}</div></th>
				<th><div class="flex align-items-center justify-content-center">{{ 'MESSAGE' | translate }}</div></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-event>
			<tr>
				<td>
					<span class="p-column-title font-semibold">{{ 'EVENT_DATE' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ getEventDateLoc(event.EventDateLoc) }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'TIMEZONE' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ event.Timezone }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'USERNAME' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ event.Username }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'DEVICE' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ event.DeviceId }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'MTMA_DIAG_FILTER_EVENT_TYPE' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ event.Category }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'EVENT' | translate }}</span>
					<div class="flex align-items-center justify-content-center"> {{ event.Description | translate }} </div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'MESSAGE' | translate }}</span>
					<div class="flex align-items-center justify-content-center"> {{ event.Message }} </div>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="confDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>